"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Bildexport-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}]
 * @param {string} [options.label='Bild herunterladen']
 * @param {Object<string,*>} options.requests
 * @param {string} options.requests.exportUrl
 */
gc.gis.module.GCImageExport = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	var self = this;

	/**
	 * @type {Object<string,*>}
	 */
	this.options       = options;
	/**
	 * @type {gc.gis.map.GCMapView}
	 */
	this.map           = options.map || gc.gis.iface.map;
	/**
	 * @type {string}
	 */
	this.label         = options.label || 'Bild herunterladen';
	/**
	 * @type {string}
	 */
	this.export_url = options.requests.exportUrl;


	this._render();

    // als Sub-Modul von Tools
    gc.gis.iface.onModuleAvailable(this, 'GCTools', function(module) {
        gc.gis.assert.isInstance(module, gc.gis.module.GCTools);
        self.launcher_content = module.addModule(self, this.getElement(), 'ms ms-img');
    });
};
gc.gis.module.GCImageExport.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 * @return {jQuery}
 */
gc.gis.module.GCImageExport.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCImageExport.prototype._render = function()
{
	var self = this;

	this.element_panel = new gc.gis.module.GCImageExport.Panel({
		module: self,
		active: self.active,
		headline: self.label
	});
	return this.element_panel;
};

/**
 * Exportiert das aktuelle Kartenbild in eine Datei und gibt es dem Nutzer zurück.
 *
 * @param {string} format
 * @param {bool} world_file
 */
gc.gis.module.GCImageExport.prototype.exportImage = function(format, world_file)
{
	var self = this;

	var params = {
		format: format,
		world_file: world_file ? 1 : 0,
		layers: [],
		size: this.map.getSize(),
		crs: this.map.getProjection(),
		bbox: this.map.getViewportExtent()
	};

	var layers = this.map.getReallyVisibleLayers();
	for(var i=0; i<layers.length; i++)
	{
		if( !(layers[i] instanceof gc.gis.layer.GCGroupLayer) )
		{
			params.layers.push(layers[i].toObject());
		}
	}


	if (this.map.getMap().numTrackingLayersFeatures() > 0)
	{
		jQuery.when(this.map.getCanvasTrackingLayerDump())
			.done(function (dump) {
				params.trackinglayers = dump;
				gc.gis.iface.request.download(self.export_url, {params: JSON.stringify(params)});
			});
	}
	else
	{
		gc.gis.iface.request.download(self.export_url, {params: JSON.stringify(params)});
	}
};
